import {Anchor, Center, rem, Text} from '@mantine/core';
import type {AnchorProps} from '@mantine/core';
import {IconArrowRight} from '@tabler/icons-react';
import React from 'react';

/**
 * Dimmed inline anchor with a label and trailing arrow icon — used for
 * "view all" / drill-down style navigation links.
 * @registry Dimmed text link with trailing arrow icon.
 *
 * Pass `component` (e.g. router `Link`) plus its link props (`to`/`href`)
 * through `...rest`; without `component` it renders a plain `<a>`.
 */
export interface NavAnchorProps extends Omit<AnchorProps, 'children'> {
  text: string;
  target?: React.HTMLAttributeAnchorTarget;
  component?: React.ElementType;
  /** Additional props (e.g. `to`) forwarded to a custom `component`. */
  [key: string]: unknown;
}

export const NavAnchor: React.FC<NavAnchorProps> = ({
  component,
  text,
  target,
  ...rest
}) => {
  return (
    <Anchor
      c="dimmed"
      size="sm"
      component={component as any}
      target={target}
      {...rest}>
      <Center inline>
        <Text mr="xs">{text}</Text>
        <IconArrowRight
          style={{width: rem(14), height: rem(14)}}
          stroke={1.5}
        />
      </Center>
    </Anchor>
  );
};
